import * as auth0 from "auth0-js";
import { APP_URL } from "src/core/constants";
const loginURI = window.location.origin.includes('test')
? `https://${process.env.REACT_APP_NGROK_SUBDOMAIN}.ngrok.io/login`
: `${APP_URL}/login`;

class Auth {
  public auth0: any;
  constructor() {
    
    this.auth0 = new auth0.WebAuth({
      domain: "spaceagent.au.auth0.com",
      clientID: "x7Cltb78dI02tRtujDBHPpboY1DdzNM_",
      redirectUri: loginURI,
      audience: "https://spaceagent.au.auth0.com/userinfo",
      responseType: "token id_token",
      scope: "openid email profile"
    });
  }

  public login = () => {
    this.auth0.authorize();
  };
  public handleAuthentication = () => {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err: any, authResult: any) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          this.auth0.client.userInfo(
            authResult.accessToken,
            (err2: any, result: any) => {
              resolve({
                email: result.email,
                name: result.name,
                given_name: result.given_name
              });
            }
          );
        } else if (err) {
          console.log(err);
          reject(false);
        }
      });
    });
  };

  public getUserInfo = () => {
    return new Promise((resolve, reject) => {
      const accessToken = this.getAccessToken();
      this.auth0.client.userInfo(accessToken, (err2: any, result: any) => {
        resolve({
          email: result.email,
          name: result.name,
          given_name: result.given_name
        });
      });
    });
  };

  public setSession(authResult: any) {
    // Set the time that the Access Token will expire at
    const expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
  }

  public clearSession() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('viewsSelections')
    
    this.auth0.logout({
      returnTo: loginURI,
      clientID: 'TNqG1ago6JMnRD8cxcuvw0lWO1QsEAJh'
    })
    }
  
  public getAccessToken = () => {
    return localStorage.getItem("access_token") || "";
  };

  public isAuthenticated = (): boolean => {
    // Check whether the current time is past the
    // Access Token's expiry time

    const accessToken = localStorage.getItem("access_token") || "";

    const expiresAt = localStorage.getItem("expires_at") || "";

    if (!accessToken || new Date().getTime() > Number(expiresAt)) {
      return false;
    } else {
      return true;
    }
  };
}

const auth = new Auth();
export default auth;



// WEBPACK FOOTER //
// ./src/lib/Auth.ts